import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getadminUserHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "adminregistration", ...action.payload }),
		);
		yield put({
			type: types.GET_ADMIN_USERS_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_ADMIN_USERS_ERROR,
			payload,
		});
	}
}

export function* getadminUserWatcherSaga() {
	yield takeLatest(types.GET_ADMIN_USERS_START, getadminUserHandlerSaga);
}

//create

//delete

function* deleteadminUserHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("adminregistration", action.payload),
		);
		yield put({
			type: types.DELETE_ADMIN_USERS_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_ADMIN_USERS_ERROR,
			payload,
		});
	}
}

export function* deleteadminUserWatcherSaga() {
	yield takeLatest(types.DELETE_ADMIN_USERS_START, deleteadminUserHandlerSaga);
}

//update
